import cn from 'classnames'
import type React from 'react'
import type { KindEntity } from 'types/domain'

import 'components/graph/controls/controls.less'
import 'components/graph/controls/kindControl.less'

type KindControlProps = {
  kind?: KindEntity | null | undefined
  onClick?: (() => void) | undefined
  showColorDot?: boolean | undefined
}

const KindControl = ({ kind, onClick, showColorDot = false }: KindControlProps) => {
  const label = kind?.data.label || 'Set kind'
  const color = kind?.data.styles.color

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      className={cn('control', 'kind-control', { clickable: !!onClick })}
      data-graph-type="control"
      title={label}
      {...(onClick ? { role: 'button', tabIndex: 0, onClick, onKeyDown } : {})}
    >
      {showColorDot ? <span className="kind-dot" style={color ? { backgroundColor: color } : undefined} /> : null}
      <span className={cn('kind-label', { placeholder: color == null })} style={color ? { color } : undefined}>
        {label}
      </span>
    </div>
  )
}

export default KindControl
